import moment from 'moment';
var normalizedDate = function (day) {
    return moment(day.toArray().slice(0, 3));
};
/**
 * An alternative to moment's `isSame(date, 'day')` that ignores timezones
 */
export function isSameDay(day1, day2) {
    return normalizedDate(day1).isSame(normalizedDate(day2));
}
/**
 * An alternative to moment's `date.isBetween(min, max, 'day', '[]')` that
 * ignores timezones.
 *
 * The comparison is inclusive of the min and max dates (i.e. true if date ==
 * min or date == max)
 */
export function isDateBetween(date, min, max) {
    return normalizedDate(date).isBetween(normalizedDate(min), normalizedDate(max), 'day', '[]');
}
export function isWeekend(date) {
    return date.day() === 0 || date.day() === 6;
}
//# sourceMappingURL=utils.js.map